import Select, { SelectProps } from "@/shared/form/select";
import { useTranslations } from "use-intl";

export function GroupSelectView({ options, ...props }: SelectProps) {
  const t = useTranslations("AttributeSelectView");

  return (
    <Select
      allowClear
      placeholder={t("Select attribute group")}
      className="w-full"
      options={options}
      {...props}
    />
  );
}
